import { render, staticRenderFns } from "./order-detail2.vue?vue&type=template&id=72ba0150&scoped=true&"
import script from "./order-detail2.vue?vue&type=script&lang=js&"
export * from "./order-detail2.vue?vue&type=script&lang=js&"
import style0 from "./order-detail2.vue?vue&type=style&index=0&id=72ba0150&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba0150",
  null
  
)

export default component.exports